var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeave({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#455079;stroke:#455079;stroke-linecap:round;stroke-width:0.3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1156 -1537)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20,
    transform: "translate(1156 1537)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.371,10.719v1.094A2.19,2.19,0,0,1,8.184,14h-5.5A2.19,2.19,0,0,1,.5,11.812V2.188A2.19,2.19,0,0,1,2.687,0h5.5a2.19,2.19,0,0,1,2.188,2.188V3.281a.547.547,0,0,1-1.094,0V2.188A1.1,1.1,0,0,0,8.184,1.094h-5.5A1.1,1.1,0,0,0,1.594,2.188v9.625a1.1,1.1,0,0,0,1.094,1.094h5.5a1.1,1.1,0,0,0,1.094-1.094V10.719a.547.547,0,0,1,1.094,0ZM14.1,6.061,12.875,4.836a.547.547,0,1,0-.773.773l.871.871H6.406a.547.547,0,1,0,0,1.094h6.566l-.871.871a.547.547,0,1,0,.773.773L14.1,7.994a1.369,1.369,0,0,0,0-1.934Zm0,0",
    transform: "translate(1159.724 1540)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeave);
export default __webpack_public_path__ + "static/media/leave.3e3537c5a5b09fb95e5fb6dabd8d2f78.svg";
export { ForwardRef as ReactComponent };